


import * as Yup from "yup";

export const ChatAssignmentValidationSchema = Yup.object().shape({
    // assignment: Yup.bool().oneOf([true], "This is required field."),
    // password: Yup.string().min(6).max(24).required().label("Password"),
});
